<template>
  <component
    :is="tag"
    v-click-outside="closeDropDown"
    :class="[getSlideClass, {open:isOpen}]"
    @click="toggleDropDown"
  >
    <slot name="title">
      <a
        class="dropdown-toggle btn-rotate"
        data-toggle="dropdown"
        href="javascript:void(0)"
      >
        <i :class="icon" />
        <p class="notification">{{ title }}
          <b class="caret" />
        </p>
      </a>
    </slot>
    <ul class="dropdown-menu">
      <slot />
    </ul>
  </component>
</template>
<script>
  export default{
    name: 'DropDown',
    props: {
      title: String,
      icon: String,
      slide: {
        type: String,
        default: 'down'
      },
      tag: {
        type: String,
        default: 'div'
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    computed: {
      getSlideClass () {
        return this.slide === 'down' ? 'dropdown' : 'dropup'
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
      },
      closeDropDown () {
        this.isOpen = false
      }
    }
  }
</script>
